import * as swcHelpers from '@swc/helpers';
import { mapServerToProductBase } from './map-server-to-product-base.js';
import { mapServerToAccessoriesVariant } from '../variant-mappers/map-server-to-accessories-variant.js';

const mapServerToAccessoriesProduct = (serverProduct, slug, locale)=>{
    const variants = mapServerToAccessoriesVariant(serverProduct, slug, locale);
    if (!variants || variants.length === 0) {
        return undefined;
    }
    return swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants), {
        productType: 'Accessories',
        isOfferedWithPrescriptions: false
    });
};

export { mapServerToAccessoriesProduct };
//# sourceMappingURL=map-server-to-accessories-product.js.map
